import { Text, Html, ContactShadows, PresentationControls, Float, Environment, useGLTF } from '@react-three/drei'

// 元教材が読み込んでいたモデル(vazxmixjsiawhamofees.supabase.co)は配布元の
// Supabaseプロジェクトごと削除されておりDNSすら解決しない状態だったため、
// CC-BYライセンスの代替モデルに差し替えている
// (Alex Safayan「Laptop / MacBook Pro」、poly.pizza、
// public/models/macbook/CREDIT.txt参照)。形状は元教材のMacBookそのもの
// ではないため、スクリーン位置(Html)・rectAreaLightの位置は元教材の
// 値のまま流用せず、このモデルのバウンディングボックスを実測して
// 再調整している(下記SCREEN_*定数)。
const MODEL_URL = './models/macbook/macbook.glb'

// public/models/macbook/macbook.glbをGLTFLoaderで読み込み、
// THREE.Box3().setFromObject()で実測した値(ネイティブのモデル座標系)。
const SCREEN_POSITION = [ 0.02, 0.82, -0.64 ]
const SCREEN_ROTATION_X = -0.05

export default function Experience()
{
    const computer = useGLTF(MODEL_URL)

    return <>

        <color args={ [ '#241a1a' ] } attach="background" />

        <Environment preset="city" />

        <PresentationControls
            global
            rotation={ [ 0.13, 0.1, 0 ] }
            polar={ [ - 0.4, 0.2 ] }
            azimuth={ [ - 1, 0.75 ] }
            damping={ 0.1 }
            snap
        >
            <Float rotationIntensity={ 0.4 } >
                <rectAreaLight
                    width={ 2.5 }
                    height={ 1.65 }
                    intensity={ 65 }
                    color={ '#ff6900' }
                    rotation={ [ - 0.1, Math.PI, 0 ] }
                    position={ [ 0, 0.55, - 1.15 ] }
                />

                <primitive
                    object={ computer.scene }
                    position-y={ - 1.2 }
                    // rotation-x={ 0.13 }
                >
                    {/*
                      元教材はbruno-simon.com(教材制作者本人の実サイト)を
                      iframeで埋め込んでいたが、第三者の実サイトをそのまま
                      使うわけにいかないため、自社サイト(portfolio.
                      pixmichelangelo.com)を埋め込む形に変更している。
                      distanceFactor・CSSサイズ(style.cssの.htmlScreen)は
                      元教材の値のまま(カメラ設定も変更していないため、
                      画面の実寸自体は元教材と同じになる)。position/
                      rotation-xのみ、差し替えたモデルのスクリーン位置に
                      合わせて再調整している。
                    */}
                    <Html
                        transform
                        wrapperClass="htmlScreen"
                        distanceFactor={ 1.17 }
                        position={ SCREEN_POSITION }
                        rotation-x={ SCREEN_ROTATION_X }
                    >
                        <iframe src="https://portfolio.pixmichelangelo.com" />
                    </Html>
                </primitive>

                {/*
                  元教材はBangers(コミック風の飾り文字)を使用していたが、
                  この書体は大文字/小文字が同じ字形になる仕様(unicase)で、
                  "Pix Michelangelo"のように大文字/小文字を区別した表記が
                  そのまま反映されない。区別して表示するため、pf-01
                  (メインサイト)と同系統のMontserrat Boldに差し替えている。
                */}
                <Text
                    font="./fonts/Montserrat-Bold.ttf"
                    fontSize={ 1 }
                    position={ [ 2, 0.75, 0.75 ] }
                    rotation-y={ - 1.25 }
                    maxWidth={ 2 }
                >
                    Pix Michelangelo
                </Text>
            </Float>
        </PresentationControls>

        <ContactShadows
            position-y={ - 1.4 }
            opacity={ 0.4 }
            scale={ 5 }
            blur={ 2.4 }
        />

    </>
}